<template>
  <div class="stripe-subscription display">
    <div v-if="enterprise.billingCustomer.id">
      <div class="md-layout md-gutter" v-if="enterprise.billingCustomer.deleted">
        <div class="md-layout-item md-small-size-100 mb-1">
          <span class="md-subheading">
            Customer <CustomerText v-bind:customerId="enterprise.owner.sCustomerId" /> deleted.
          </span>
        </div>
      </div>
      <div class="md-layout md-gutter" v-if="!enterprise.billingCustomer.deleted">
        <div class="md-layout-item md-small-size-100 mb-1">
          <p class="md-subheading">Created at</p>
          <span class="md-subheading">
            {{ enterprise.billingCustomer.created | subscriptionDate }}
          </span>
        </div>
        <div class="md-layout-item md-small-size-100 mb-1">
          <p class="md-subheading">E-mail</p>
          <span class="md-subheading">
            {{ enterprise.billingCustomer.email }}
          </span>
        </div>
        <div class="md-layout-item md-small-size-100 mb-1">
          <p class="md-subheading">Delinquent</p>
          <span class="md-subheading">
            {{ enterprise.billingCustomer.delinquent | yesno }}
          </span>
        </div>
      </div>
    </div>
    <div v-if="!enterprise.billingCustomer.id && enterprise.owner.sCustomerId">
      <p class="md-subheading">
        Stripe customer {{ enterprise.owner.sCustomerId }} could not be fetched.
      </p>
    </div>
    <div v-if="!enterprise.owner.sCustomerId">
      <p class="md-subheading">
        Stripe customer not configured for this business.
      </p>
    </div>
  </div>
</template>
<script type="ts">
import moment from 'moment';
import CustomerText from '@/components/billing/customer-text.vue';

export default {
  name: 'stripe-customer-display',
  props: ['enterprise'],
  components: {
    CustomerText,
  },
  filters: {
    subscriptionDate(input) {
      return moment.unix(input).format('DD/MM/YYYY HH:mm:ss');
    },
    yesno(input) {
      if (input === true) return 'Yes';

      return 'No';
    },
  },
};
</script>
